export function chunk<T>(data: readonly T[], size: number) {
  const result: T[][] = [];
  for (let i = 0, j = data.length; i < j; i += size) {
    result.push(data.slice(i, i + size));
  }

  return result;
}

export function flatChildrenDeep<T extends { children: T[] }>(items: T[]): T[] {
  let children = [] as T[];

  return items
    .map((item) => {
      const copiedItem = { ...item };
      if (copiedItem.children && copiedItem.children.length) {
        children = [...children, ...copiedItem.children];
      }
      return copiedItem;
    })
    .concat(children.length ? flatChildrenDeep(children) : children);
}
